import { React } from "react";
import BranchesContent from "../../Component/Branches/BranchesContent";

function Branches() {
  return  <BranchesContent />
      
}

export default Branches;
